import script from "./ProductFarmName.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFarmName.vue?vue&type=script&setup=true&lang=js"

import "./ProductFarmName.vue?vue&type=style&index=0&id=44aff00c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44aff00c"]])

export default __exports__